import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: {
              borderRadius: "16px",
              fontFamily: "Nunito, sans-serif",
              fontWeight: 600,
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
